import React from 'react';
import { Text } from '@ui';
import './PerformanceFlagStyles.scss';
/**
 * A single performance flag row: white card, gray border, red accent bar on the left.
 * Presentational only; the copy is built by the consumer.
 */
function PerformanceFlag({ icon, title, description, meta, className }) {
    return (React.createElement("div", { className: ['iim-performance-flag', className].filter(Boolean).join(' ') },
        React.createElement("i", { className: `fa-light ${icon} iim-performance-flag__icon`, "aria-hidden": "true" }),
        React.createElement("div", { className: "iim-performance-flag__content" },
            React.createElement(Text, { variant: "x-small", as: "p", className: "iim-performance-flag__title" }, title),
            React.createElement(Text, { variant: "body", as: "p", className: "iim-performance-flag__description" }, description),
            meta && (React.createElement("p", { className: "iim-performance-flag__meta" },
                React.createElement("i", { className: "fa-light fa-calendar iim-performance-flag__meta-icon", "aria-hidden": "true" }),
                React.createElement(Text, { variant: "body", as: "span" }, meta))))));
}
export default PerformanceFlag;
